import * as React from "react";
import { Button } from "@skbkontur/react-ui";
import { KonturColors } from "@skbkontur/colors";
import type { ButtonProps } from "@skbkontur/react-ui";

type ReservedProps = "onMouseOver" | "onMouseOut" | "use";
type Props = Omit<ButtonProps, ReservedProps>;

export const ModalFormRemoveButton = (props: Props) => (
    <Button
        {...props}
        use={"text"}
        theme={{
            transitionDuration: "0",
            btnTextHoverBg: KonturColors.errorStatesShapeHoverRed70,
            btnTextActiveBg: KonturColors.errorStatesShapePressedRed80,
            btnTextHoverTextColor: KonturColors.grayscaleWhiteFFF,
        }}>
        Удалить
    </Button>
);
